package com.trevorwiebe.timesheet.core.data

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

class ImageExtractionService {
    @OptIn(ExperimentalEncodingApi::class)
    suspend inline fun <reified T : Any> extract(imageBytes: ByteArray, prompt: String): T {
        val base64 = Base64.encode(imageBytes)
        val result = Firebase.functions
            .httpsCallable("extractImageData")
            .invoke(mapOf("imageBase64" to base64, "prompt" to prompt))
        val data = result.data<T>()
        return data
    }
}
